import importer from "common/importer";

const getChatbotResponse = importer("Sagas/Chatbot/getChatbotResponse/main");
// const getChatbotInitialState = importer(
//   "Sagas/Chatbot/getChatbotInitialState/main"
// );
const getChatbotResponseSuccess = importer(
  "Sagas/Chatbot/getChatbotResponse/success"
);
const getChatbotResponseFailure = importer(
  "Sagas/Chatbot/getChatbotResponse/failure"
);

export default {
  getChatbotResponse,
  //   getChatbotInitialState,
  getChatbotResponseSuccess,
  getChatbotResponseFailure,
};
